import { AppDocument } from '../Types';

export const isDev = !['production', 'staging'].includes(
    process.env.REACT_APP_ENV ?? 'development'
);

export const isProd = process.env.REACT_APP_ENV === 'production';

export const API_ENDPOINT =
    (document as AppDocument).API_ENDPOINT ??
    process.env.REACT_APP_API_ENDPOINT ??
    (isProd ? 'https://api.snackpass.co' : 'https://staging-api.snackpass.co');
